export const navigate = (url) => {
  window.location.replace(url);
};

export const getQueryParam = (param) =>
  new URLSearchParams(window.location.search).get(param);
